//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drafting.js";
import "../no/TaggedObject.js";
let d=[[[0,"AllowInsideGeometry",1,0],[0,"EqualDimensionTolerance",1,0],[0,"HideFeetAndInchMarks",1,0],[0,"Increment",1,0],[0,"LowerThreshold",1,0],[0,"MaximumGapToGeometry",1,0],[0,"MinimumGapBetweenAnnotations",1,0],[0,"MinimumGapToGeometry",1,0],[0,"ReferenceGeometryGapTolerance",1,0],[0,"RoundFeetAndInches",1,0],[0,"UseFeetInchesAndFraction",1,0]],[[["numRules"],"GetRulesList",{R_:{rules:""}},0,0],[["rules"],"SetRulesList",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drafting.AutomationRuleBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drafting.AutomationRuleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;